import {
    ActionReducer,
    ActionReducerMap,
    createFeatureSelector,
    createSelector,
    MetaReducer,
} from '@ngrx/store';
import { environment } from '../../../environments/environment';
import { CommonFeatureState, HomeFeatureState } from '..';

export interface AppState {
    common?: CommonFeatureState;
    home?: HomeFeatureState;
}

export const reducers: ActionReducerMap<AppState> = {};

export const metaReducers: MetaReducer<AppState>[] = !environment.production
    ? []
    : [];
